import { Injectable, inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpContextToken,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

/**
 * Context token to explicitly skip showing the centralized spinner for a specific request.
 */
export const SKIP_LOADING = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldSkipLoading(req)) {
      return next.handle(req);
    }

    const generation = this.loadingService.show();

    return next.handle(req).pipe(
      finalize(() => {
        this.loadingService.hide(generation);
      })
    );
  }

  private shouldSkipLoading(req: HttpRequest<any>): boolean {
    if (req.context.get(SKIP_LOADING)) {
      return true;
    }
    const url = req.url;
    return (
      url.includes('/sse/') ||
      url.includes('/health') ||
      url.includes('/ping') ||
      url.includes('silent-check-sso')
    );
  }
}
